// Aditya Birla Electricals — "Propulse" Cables & Wires Learning Academy brand constants.
// Source of truth for ALL brand colours, names, and copy. Anything in JSX should import
// from here (no hardcoded strings). BrandSettings doc in Mongo is the runtime override.
export const BRAND = {
    // Identity
    clientName: 'Aditya Birla Electricals',
    academyName: 'Propulse Cables & Wires Learning Academy',
    shortName: 'Propulse Academy',
    productLine: 'Propulse Cables & Wires',
    tagline: "Powering India's Future",
    poweredBy: 'An Aditya Birla Electricals Initiative',
    // Logos — self-hosted
    logoUrl: '/propulse-logo.jpeg',
    logoDarkUrl: '/propulse-logo.jpeg',
    legacyLogoUrl: '/propulse-logo.jpeg',
    // Colours — Aditya Birla Electricals palette (black + Propulse gold) with sun accents
    colors: {
        sun: '#F47920',          // ABE sun orange
        navy: '#231F20',         // near-black primary surface
        yellow: '#FFD400',       // Propulse golden yellow
        black: '#231F20',
        red: '#B5202E',          // ABE deep red
        orange: '#F47920',
        sidebar: '#02160E',      // deep forest green sidebar (UAT dark-green admin)
    },
};

// Brand logo — Aditya Birla Electricals "Propulse" wordmark, rendered inside a clean
// white chip so it reads well on both light and dark surfaces.
import React, { useState } from 'react';
import { useTheme } from '@/lib/theme';

export function BrandLogo({ className = '', dark = false, compact = false }) {
    const [src, setSrc] = useState(BRAND.logoUrl);
    const { theme } = useTheme();
    const effDark = dark || theme === 'dark';
    return (
        <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
            <div className="relative flex-shrink-0 bg-white rounded-lg p-1 shadow-sm ring-1 ring-black/5">
                <img
                    src={src}
                    onError={() => setSrc(BRAND.legacyLogoUrl)}
                    alt={BRAND.clientName}
                    className="h-8 sm:h-9 w-auto object-contain"
                    style={{ maxWidth: '90px' }}
                />
            </div>
            {!compact && (
                <div className="leading-tight border-l-2 pl-2.5 hidden sm:block" style={{ borderColor: effDark ? BRAND.colors.yellow : BRAND.colors.black }}>
                    <div
                        className="font-display font-extrabold tracking-tight text-sm sm:text-base"
                        style={{ color: effDark ? '#FFFFFF' : BRAND.colors.black }}
                    >
                        Propulse Academy
                    </div>
                    <div className="text-[10px] font-medium tracking-wide" style={{ color: effDark ? BRAND.colors.yellow : '#737373' }}>
                        {BRAND.poweredBy}
                    </div>
                </div>
            )}
        </div>
    );
}
